export function injectionMoldingPartNumberPrefix(customerPartNumberPrefix: string): string {
    const normalizedCustomerPrefix = customerPartNumberPrefix.trim().toUpperCase();
    return normalizedCustomerPrefix ? `${normalizedCustomerPrefix}-IN` : '';
}

export function stripInjectionMoldingPartNumberPrefix(
    partNumber: string,
    customerPartNumberPrefix: string,
): string {
    const forcedPrefix = injectionMoldingPartNumberPrefix(customerPartNumberPrefix);
    if (forcedPrefix && partNumber.toUpperCase().startsWith(forcedPrefix)) {
        return partNumber.slice(forcedPrefix.length);
    }

    const legacyPrefix = customerPartNumberPrefix.trim();
    if (legacyPrefix && partNumber.toUpperCase().startsWith(legacyPrefix.toUpperCase())) {
        return partNumber.slice(legacyPrefix.length);
    }

    return partNumber;
}
